/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect } from 'react';

import Colors from "constants/Colors";
import Icon from "components/Icon";
import HasPermission from 'components/HasPermission/index';
import { Col, Row } from "components/Grid";

function ListEnquiryButtons(props) {
  const [isDeclined, setIsDeclined] = useState(false);

  useEffect(() => {
    if (props.listItem) {
      if (props.listItem.idDomainStatusOper === 2) setIsDeclined(true)
    }
  }, [])

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', flexDirection: 'column' }}>
      <Row className="align-items-center justify-content-start" style={{ width: 65 }}>
        <HasPermission permission={true}>
          <Icon
            name="edit"
            title="Editar Cotação"
            onClick={() => {
              props.editRoute(props.listItem.idOperation, props.listItem.idProduct)
            }}
            style={props.listItem.isEdit ? icon : opacityAllowed} />
        </HasPermission>

        <Icon
          title="Gerenciar Documentos"
          name="folder"
          onClick={() => props.toDocument()} />

        {/* {isDeclined ? <></> :
        <Icon
          name="check-ok"
          onClick={() => {
            if (props.listItem.idDomainStatusOper !== 5) return;
            props.setDialogConfirmationEmission({visible:true});
            props.setDocumentOrder({idOperation: props.idOperation})
          }}
          style={props.listItem.idDomainStatusOper !== 5 ? opacity : {}}
            >
        </Icon>
      } */}

      </Row>
    </div>
  )
}

const icon = {
  color: Colors.GRAY[6],
  marginRight: 5
};

const opacity = {
  color: Colors.GRAY[5],
  opacity: 0.5,
  cursor: "not-allowed",
  marginRight: 5
};

const opacityAllowed = {
  color: Colors.GRAY[5],
  opacity: 0.5,
  marginRight: 5
};

export default ListEnquiryButtons;